import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PageNavigation from "@/components/PageNavigation";
import SEOHead from "@/components/seo/SEOHead";

export default function PoliticaPrivacidade() {
  return (
    <>
      <SEOHead
        title="Política de Privacidade"
        description="Política de Privacidade do Vendas Trainer. Saiba como coletamos, usamos e protegemos seus dados pessoais em conformidade com a LGPD."
        keywords="privacidade, LGPD, dados pessoais, proteção de dados, política de privacidade"
        canonicalUrl="https://bianchimbusiness.com.br/politica-privacidade"
      />

      <Header />

      <main 
        id="main-content"
        className="min-h-screen bg-background pt-20"
        role="main"
        aria-labelledby="page-title"
      >
        <article className="container mx-auto px-4 py-16 max-w-4xl">
          <header>
            <h1 
              id="page-title"
              className="text-4xl font-bold text-foreground mb-8"
            >
              Política de Privacidade
            </h1>
          </header>
          
          <div className="prose prose-lg dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p className="text-lg">
              <strong>Última atualização:</strong> Janeiro de 2026
            </p>

            <section className="space-y-4" aria-labelledby="intro-section">
              <h2 id="intro-section" className="text-2xl font-semibold text-foreground">
                1. Introdução
              </h2>
              <p>
                A Bianchim Business ("nós", "nosso" ou "empresa"), responsável pelo Vendas Trainer, está comprometida em proteger a privacidade e os dados pessoais de nossos usuários. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.
              </p>
            </section>

            <section className="space-y-4" aria-labelledby="data-section">
              <h2 id="data-section" className="text-2xl font-semibold text-foreground">
                2. Dados que Coletamos
              </h2>
              <p>Podemos coletar os seguintes tipos de informações:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Dados de identificação:</strong> nome, e-mail, telefone, empresa</li>
                <li><strong>Dados de uso:</strong> informações sobre como você utiliza nossa plataforma</li>
                <li><strong>Dados de desempenho:</strong> resultados de simulações e treinamentos</li>
                <li><strong>Dados técnicos:</strong> endereço IP, tipo de navegador, dispositivo</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="usage-section">
              <h2 id="usage-section" className="text-2xl font-semibold text-foreground">
                3. Como Usamos seus Dados
              </h2>
              <p>Utilizamos suas informações para:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Fornecer e melhorar nossos serviços de treinamento</li>
                <li>Personalizar sua experiência na plataforma</li>
                <li>Enviar comunicações relevantes sobre o serviço</li>
                <li>Analisar o desempenho e gerar relatórios</li>
                <li>Cumprir obrigações legais</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="sharing-section">
              <h2 id="sharing-section" className="text-2xl font-semibold text-foreground">
                4. Compartilhamento de Dados
              </h2>
              <p>
                Não vendemos seus dados pessoais. Podemos compartilhar informações apenas com:
              </p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Prestadores de serviços essenciais (hospedagem, processamento de pagamentos)</li>
                <li>Autoridades quando exigido por lei</li>
                <li>Sua empresa, caso seja um usuário corporativo</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="security-section">
              <h2 id="security-section" className="text-2xl font-semibold text-foreground">
                5. Segurança dos Dados
              </h2>
              <p>
                Implementamos medidas técnicas e organizacionais adequadas para proteger seus dados, incluindo criptografia, controle de acesso e monitoramento contínuo.
              </p>
            </section>

            <section className="space-y-4" aria-labelledby="rights-section">
              <h2 id="rights-section" className="text-2xl font-semibold text-foreground">
                6. Seus Direitos
              </h2>
              <p>Você tem direito a:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incorretos</li>
                <li>Solicitar exclusão de seus dados</li>
                <li>Revogar consentimento</li>
                <li>Portabilidade dos dados</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="contact-section">
              <h2 id="contact-section" className="text-2xl font-semibold text-foreground">
                7. Contato
              </h2>
              <p>
                Para exercer seus direitos ou esclarecer dúvidas sobre esta política, entre em contato:
              </p>
              <address className="not-italic space-y-2">
                <p>
                  <strong>E-mail:</strong>{" "}
                  <a 
                    href="mailto:junior@bianchimbusiness.com.br"
                    className="text-primary hover:underline"
                  >
                    junior@bianchimbusiness.com.br
                  </a>
                </p>
                <p>
                  <strong>Telefone:</strong>{" "}
                  <a 
                    href="tel:+5516981960018"
                    className="text-primary hover:underline"
                  >
                    +55 (16) 98196-0018
                  </a>
                </p>
                <p>
                  <strong>Endereço:</strong> Rua Danilo Micalli, 50 - Santa Felícia, São Carlos – SP – CEP: 13563-264
                </p>
              </address>
            </section>
          </div>
        </article>
      </main>

      <PageNavigation />
      <Footer />
    </>
  );
}
